import {Component, Input, ElementRef, ViewChild, Renderer2} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { ParticipantPropertiesPage } from '../participantProperties/participantProperties';
import { ApiServiceProvider } from '../../providers/api.service';
import { FiltersServiceProvider } from '../../providers/filters.service';

@IonicPage()
@Component({
  selector: 'page-group-properties',
  templateUrl: 'groupProperties.html',
  
})
export class GroupPropertiesPage {

    // @Input() group: object;
    public group;

    public searchTerm;
    public originalMembers;
    public filteredMembers;

    private selectedMember;
    private selectedMemberRoot = ParticipantPropertiesPage;


    @ViewChild('memberPropertiesContainer') memberPropertiesContainer;
    @ViewChild('memberListingContainer') memberListingContainer;

    constructor(private params:NavParams,
                private events:Events,
                private renderer:Renderer2,
                private filters:FiltersServiceProvider){

      console.log(params);
      this.group=params.data;
      this.originalMembers = this.group.members;
      this.filteredMembers = Object.assign([], this.group.members);

      this.events.subscribe("groupProperties:groupChanged", (group)=>{
        console.log("group changed!", group)
        this.group = group;
        this.originalMembers = this.group.members;
        this.filteredMembers = Object.assign([], this.group.members);
      })
    }

    ionViewDidLoad() {
    }

    ionViewWillUnload(){
    }

    memberSelected(event, member)
    {
      this.selectedMember = member;
      this.events.publish("participantProperties:participantChanged", member);

      //un-highlight previously highlighted list items
      let selectedMemberElements = this.memberListingContainer.nativeElement.querySelectorAll('.selected');
      for(let i=0; i<selectedMemberElements.length; i++) {
        this.renderer.removeClass(selectedMemberElements[i], "selected");
      }
      //highlight currently selected list item
      let selectedMemberElement = event.currentTarget;
      this.renderer.addClass(selectedMemberElement, "selected")
    }

    setFilteredItems()
    {
      this.filteredMembers = this.filters.filterObjectArray(this.searchTerm, this.originalMembers, this.group.name+"members");
    }
  
    
}



// WEBPACK FOOTER //
// ./src/pages/groupProperties/groupProperties.ts